import { Component, OnDestroy, OnInit } from '@angular/core';
import { BreadcrumbItem, SortDirection, SortEvent } from '@pwc-bei/ui';
import { Observable, Subject, Subscription } from 'rxjs';

import { ApiResource, PageableResponse } from '@pwc-bei/common';
import { RoutePath } from 'src/app/enums/route-path.enum';
import { AuthorityCodeEnum } from 'src/app/enums/security/authority-code.enum';

@Component({
    selector: 'app-base-page',
    template: '',
    standalone: false
})
export class BasePage implements OnInit, OnDestroy {
  subscriptions: Subscription[] = [];

  RoutePath = RoutePath;
  AuthorityCodeEnum = AuthorityCodeEnum;

  breadcrumbs: BreadcrumbItem[] = [];

  sortDirection: SortDirection = '';
  sortType: string;
  sortReverse: number = 0;

  searchTriggerSubject: Subject<void> = new Subject<void>();
  searchTrigger$: Observable<void> = this.searchTriggerSubject.asObservable();

  pagination: PageableResponse<ApiResource[]>;
  currentPage = 0;
  pageSize = 10;

  ngOnInit(): void {
    this.initBreadcrumbs();
  }

  ngOnDestroy(): void {
    this.cleanSubscriptions();
  }

  cleanSubscriptions() {
    if (this.subscriptions == null) {
      return;
    }

    for (const subscription of this.subscriptions) {
      subscription.unsubscribe();
    }
  }

  onSort($event: SortEvent): void {
    switch ($event.direction) {
    case 'asc':
      this.sortReverse = 1;
      break;
    case 'desc':
      this.sortReverse = 2;
      break;
    default:
      this.sortReverse = 0;
      break;
    }

    this.sortType = $event.column;
    this.sortDirection = $event.direction;

    this.onSearch();
  }

  public onSearch(): void {
    this.searchTriggerSubject.next();
  }

  public onSearchSaveSortingRule(sortingRule: string): void {
    localStorage.setItem('sortingRule', sortingRule);
    this.searchTriggerSubject.next();
  }

  onPageChange(page: number): void {
    this.currentPage = page - 1;
    this.onSearch();
  }

  trackByIndex(index: number, obj: any): any {
    return index;
  }

  initBreadcrumbs(): void {}

  buildRoute(segments: string[]): string {
    return RoutePath.SLASH + segments.join(RoutePath.SLASH);
  }
}
